import { render, staticRenderFns } from "./Prints.vue?vue&type=template&id=4629527e&scoped=true&"
import script from "./Prints.vue?vue&type=script&lang=js&"
export * from "./Prints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629527e",
  null
  
)

export default component.exports